import React, {useEffect, useState} from "react";
import EmailVerify from "../../Doctor/Components/Dashbord/EmailVerify";
import CardViews from "../../Doctor/Components/Dashbord/CardViews";

const InsuranceDashboard = () => {
    const [userdata, setUserdata] = useState({});


    useEffect(() => {
        const userData = localStorage.getItem("userData");
        console.log("userData", userData);
        if (userData) {
            setUserdata(userData);
        }
    }, []);


    return (
        <>

             
            <div className="subbody" style={{width: '100%',padding: '2% 4%'}}>
                {userdata.activation_key == null && (
                    <EmailVerify/>
                )}
                <CardViews/>

            </div>
            
        </>
    );
};

export default InsuranceDashboard;
